import React from 'react'
import PropTypes from 'prop-types'
import Heading from 'components/Heading'

export const MobileApp = ({ mode }) => {
	return <div className='u-bg--selago'>
		<div className='o-wrapper'>
			<div className='o-layout'>
				<div className='o-layout__item u-2/3@desktop'>
					<Heading
						text='Запознайте се с мобилното приложение на rates.bg'
						classes='u-text--huge u-heading-line u-heading-line-cornflower u-margin-top-large u-margin-bottom u-margin-top-huge@desktop u-margin-bottom-large@desktop' />
					<p className='u-text--large u-margin-bottom-large@desktop u-margin-bottom'>Изтегли безплатното мобилно приложение сега!</p>
					<a className='o-block o-block--left u-margin-bottom-huge@desktop u-margin-bottom u-center-on-mobile' href='https://play.google.com/store/apps/details?id=bg.devlabs.ratesbg' target='_blank' rel='noopener noreferrer'>
						<img src='/img/g-play-badge.svg' alt="Google play" />
					</a>
				</div>
				<div className='o-layout__item u-1/3@desktop u-push-none@desktop u-1/2@tablet u-push-1/4@tablet u-3/5@mobile u-push-1/5@mobile'>
					<div className='u-text--center  u-margin-vertical-none@tablet u-margin-bottom'>
						<img src={mode === 'monetary' ? '/img/mobile-app.png' : '/img/mobile-app-crypto.png'} className='u-width-100' alt='Rates.bg Mobile App' />
					</div>
				</div>
			</div>
		</div>
	</div>
}

MobileApp.propTypes = {
	mode: PropTypes.string
}

export default MobileApp
